import { render } from "./DeleteSurvey.vue?vue&type=template&id=4f9eb205&scoped=true"
import script from "./DeleteSurvey.vue?vue&type=script&lang=js"
export * from "./DeleteSurvey.vue?vue&type=script&lang=js"

import "./DeleteSurvey.vue?vue&type=style&index=0&id=4f9eb205&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9eb205"]])

export default __exports__